const BUY_UP_PENDING_POPUP = {
  buy_up_pending_report: 'buy_up_pending_report',
};

Object.freeze(BUY_UP_PENDING_POPUP);

export { BUY_UP_PENDING_POPUP };
